import i18n from '@/i18n';
interface ThemeSet {
  [k: string]: any;
  modifyVars: Record<string, any>;
}
import PageConfig from '@/theme/PageConfig';
import _ from 'lodash';
import { LocalStorage } from '@cyber-ccx/lib';

export default class Theme {
  /** 预设皮肤 */
  static preset = {
    greenblack: {
      name: i18n.t('theme-index-1992f2b8d0c7a18d2-1'),
      typeKey: 'greenblack',
      primaryColor: '#02a678',
      modifyVars: {
        '@primary-color': '#02a678',
        '@link-color': '#02a678',
        '@btn-primary-bg': '#02a678',
      },
    },
    skyblue: {
      name: i18n.t('theme-index-1992f2b8d0c7a18d2-2'),
      typeKey: 'skyblue',
      primaryColor: '#e7442d',
      modifyVars: {
        '@primary-color': '#e7442d',
        '@link-color': '#e7442d',
        '@btn-primary-bg': '#e7442d',
      },
    },
    green: {
      name: i18n.t('theme-index-1992f2b8d0c7a18d2-3'),
      typeKey: 'green',
      primaryColor: '#1FC695',
      modifyVars: {
        '@primary-color': '#1FC695',
        '@link-color': '#1FC695',
        '@btn-primary-bg': '#1FC695',
      },
    },
    graydark: {
      name: i18n.t('theme-index-1992f2b8d0c7a18d2-4'),
      typeKey: 'graydark',
      primaryColor: '#474c5a',
      modifyVars: {
        '@primary-color': '#474c5a',
        '@link-color': '#474c5a',
        '@btn-primary-bg': '#474c5a',
      },
    },
  };

  /**
   * 设置主题
   * @param set
   */
  static changeTheme = (set: ThemeSet) => {
    window.less.modifyVars(set.modifyVars);
  };

  static initTheme = () => {
    const pageConfig: PageConfig = _.assign(new PageConfig(), LocalStorage.get('pageConfig'));
    const pre: any = Theme.preset;
    window.less.modifyVars(pre[pageConfig.theme].modifyVars);
  };
}
